export const tourElementsIds = {
  dashboardTour1: "dashboardTour1",
  dashboardTour2: "dashboardTour2",
  dashboardTour3: "dashboardTour3",

  quoteTour1: "quoteTour1",
  quoteTour2: "quoteTour2",
  summaryItemSectionTour: "summaryItemSectionTour",
  quoteLivePreviewTour: "quoteLivePreviewTour",

  invoiceTour: "invoiceTour",
  invoiceItemSummaryTour: "invoiceItemSummaryTour",
  invoiceLivePreviewTour: "invoiceLivePreviewTour",

  quoteDetailsTour: "quoteDetailsTour",

  presetQuoteTour1: "presetQuoteTour1",

  settingsTour1: "settingsTour1",
} as const;

export type tourElementsIdsType = keyof typeof tourElementsIds;
